/*
参数:
url: 播放地址
playerId: vido标签的id

注意：
Chrome 66之后的版本已经禁用了自动播放功能
* */
window.startPlay = function (url, playerId, auto, controls, poster) {
    if (auto === undefined) {
        auto = true
    }
    if (controls === undefined) {
        controls = true
    }
    var options = {
        width: '100%',
        height: '100%',
        fluid: false,
        language: 'zh-CN',
        controls: controls,
        crossOrigin: 'Anonymous',
        autoplay: auto,
        loop: false,
        muted: false,
        sources: [],
        html5: {
            
            hls: {
                overrideNative: true, // 强制使用js解析HLS，而非Chrome原生
                maxRetries: 5,
                retryDelay: 1000,
            },
        },
    };
    if (poster) {
        options.poster = poster;
    }

    if (_.endsWith(url, '.m3u8')) {
        // options['techOrder'] = ['html5', 'flash'];
        // options['flash'] = {
        //     params: {
        //         wmode: 'Opaque'
        //     },
        //     swf: '/videojs/video-js.swf'
        // };
        options.sources = [
            {
                type: 'application/x-mpegURL',
                src: url,
            },
        ];
    } else if (_.endsWith(url, '.flv')) {
        options['techOrder'] = ['html5', 'flvjs'];
        options['flvjs'] = {
            mediaDataSource: {
                isLive: true,
                cors: true,
                withCredentials: false,
            },
        };
        options['flash'] = {
            params: {
                wmode: 'Opaque',
            },
            swf: '/videojs/video-js.swf',
        };
        options.sources = [
            {
                type: 'video/x-flv',
                src: url,
            },
        ];
    } else if (_.startsWith(url, 'rtmp://')) {
        options['techOrder'] = ['html5', 'flash'];
        options['flash'] = {
            params: {
                wmode: 'Opaque',
            },
            swf: '/videojs/video-js.swf',
        };
        options.sources = [
            {
                type: 'rtmp/mp4',
                src: url,
            },
        ];
    } else {
        options.sources = [
            {
                type: 'video/mp4',
                src: url,
            },
        ];
    }

    videojs.Hls.xhr.beforeRequest = function (options) {
        if (_.endsWith(getBaseUrl(options.uri), '.m3u8')) {
            options.uri = updateQueryStringParameter(options.uri, '_t', new Date().valueOf());
        }
        return options;
    };

    var player = videojs(playerId, options);

    player.ready(function () { });
    return player;
};

function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    var separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2');
    } else {
        return uri + separator + key + '=' + value;
    }
}

window.removeplayer = function (playerId) {
    if ($('#' + playerId).length > 0) {
        videojs(playerId).dispose();
    }
};

window.getBaseUrl = function (url) {
    var pos = url.indexOf('?');
    if (pos === -1) {
        return url;
    } else {
        return url.substr(0, pos);
    }
};
